/**
 * description:
 * Renders a responsive grid of resource cards (logo, title, description)
 * linking out to each resource, alternating offset shadow colors.
 */

import { Box, Typography } from "@mui/material";

const defaultShadowColors = ["#ad5d4e", "#f2c94c"];

const ResourcesTemplate = ({ images, cardColor, descColor, shadowColors = defaultShadowColors }) => {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" },
                gap: "24px",
            }}
        >
            {images.map((item, i) => (
                <Box
                    key={item.id}
                    component="a"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: "none",
                        bgcolor: cardColor,
                        borderRadius: "4px",
                        p: "22px 18px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "14px",
                        boxShadow: `8px 8px 0 ${shadowColors[i % 2]}`,
                    }}
                >
                    <Box component="img" src={item.img} alt={item.title} sx={{ height: "44px", width: "auto", objectFit: "contain", alignSelf: "flex-start" }} />
                    <Box>
                        <Typography sx={{ fontFamily: "Anton, sans-serif", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "14px", color: "primary.main" }}>
                            {item.title}
                        </Typography>
                        <Typography variant="body1" sx={{ color: descColor, mt: "6px" }}>
                            {item.description}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    );

}

export default ResourcesTemplate;
